// Import model
import { RoomCondition } from '../models/RoomCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { RoomIndexedFields } from '../models/RoomIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { RoomIndexedFieldsSerializer } from './RoomIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for RoomCondition - handles JSON serialization and deserialization with type validation
 */
export class RoomConditionSerializer {
  /**
   * Deserializes a JSON string into a RoomCondition instance
   */
  static deserialize(json: string): RoomCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a RoomCondition instance
   */
  static fromObject(obj: any): RoomCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to RoomCondition');
    }


    const instance: RoomCondition = {
      fieldName: obj['fieldName'] as RoomIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of RoomCondition instances
   */
  static deserializeArray(json: string): RoomCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a RoomCondition instance to a JSON string
   */
  static serialize(instance: RoomCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a RoomCondition instance to a plain object
   */
  static toObject(instance: RoomCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of RoomCondition instances to a JSON string
   */
  static serializeArray(instances: RoomCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
